<template>
    <div class="mt">
        <div class="d-flex flex-align-baseline">
            <p>HTML:</p>
            <a class="btn btn-sm btn-light ml-auto" @click="copy">Copiar</a>
        </div>
        <pre
            class="border border-2 border-solid border-default-2 rounded px py guide-sample-code"
        ><code>{{ rawCode }}</code></pre>

        <template v-if="$slots.js">
            <p>Javascript:</p>
            <div class="border border-2 border-solid border-default-2 rounded px py">
                <pre><code><slot name='js'></slot></code></pre>
            </div>
        </template>

        <p>Resultado:</p>
        <div
            ref="slotFrame"
            :class="{
                'border border-2 border-solid border-default-2 rounded px py': framed,
            }"
        >
            <slot></slot>
        </div>
        <hr />
    </div>
</template>

<script>
    import { copyToClipboard } from '../../../common/common';

    export default {
        name: 'GuideSampleCode',

        props: {
            code: String,
            framed: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return { rawCode: '' };
        },

        mounted() {
            // remove espaços entre tags
            const slotHtml = this.$refs.slotFrame.innerHTML
                .replace(/>(\s+)/g, '>')
                .replace(/(\s+)</g, '<');

            // indenta o código
            // src: https://stackoverflow.com/questions/26360414/javascript-how-to-correct-indentation-in-html-string
            this.rawCode = this.process(slotHtml);
        },

        methods: {
            copy() {
                copyToClipboard(this.rawCode);
            },

            process(str) {
                const div = document.createElement('div');
                div.innerHTML = str.trim();

                return this.format(div, 0).innerHTML.trim();
            },

            format(node, level) {
                const indentBefore = new Array(level++ + 1).join('  '),
                    indentAfter = new Array(level - 1).join('  ');
                let textNode;

                for (let i = 0; i < node.children.length; i++) {
                    textNode = document.createTextNode('\n' + indentBefore);
                    node.insertBefore(textNode, node.children[i]);

                    this.format(node.children[i], level);

                    if (node.lastElementChild == node.children[i]) {
                        textNode = document.createTextNode('\n' + indentAfter);
                        node.appendChild(textNode);
                    }
                }

                return node;
            },
        },
    };
</script>
